import uniqid from "uniqid";

import artifactMarkerTypes from "../constants/artifactMarkerTypes";

export default function getArtifactMarkersFromFiles({ files }) {
	const silences = files
		.flatMap((file) => {
			return file.silences.map((silence) => {
				return [silence.start + file.start, silence.end + file.start];
			});
		})
		.reduce((acc, silence) => {
			const last = acc[acc.length - 1];

			if (last && Math.abs(silence[0] - last[1]) < 50) {
				last[1] = silence[1];
			}

			return [...acc, silence];
		}, []);

	const chapters = silences.filter((silence) => {
		const length = silence[1] - silence[0];

		return length >= 4000;
	});

	const totalLength = files.reduce((acc, file) => acc + file.length, 0);

	const markers = chapters.reduce(
		(markers, chapter) => {
			const position = chapter[1] - 1000;
			const file = files.find((file) => file.start <= position && file.stop >= position);

			const distance = Math.abs(chapter[1] - totalLength);

			if (file && distance > 1000) {
				return [
					...markers,
					{
						id: uniqid(),
						type: artifactMarkerTypes.CHAPTER,
						text: "",
						fileId: file.id,
						position: Math.round(position - file.start),
					},
				];
			}

			return markers;
		},
		[
			{
				id: uniqid(),
				type: artifactMarkerTypes.CHAPTER,
				text: "",
				fileId: files[0].id,
				position: 0,
			},
		],
	);

	return markers;
}
